import React from "react";

const theme = {
  primary: "#E8540A",
  primaryLight: "#FF6B2B",
  bg: "#FFFAF5",
  text: "#1A0A00",
  textMuted: "#5A3A20",
  border: "#F0D0B0",
  gradient: "linear-gradient(135deg, #E8540A 0%, #FF8C42 100%)",
};

const MusicIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
  </svg>
);
const VideoIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
  </svg>
);
const BrushIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l9.96-9.96c.39-.39.39-1.02 0-1.41z"/>
  </svg>
);
const PdfIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"/>
  </svg>
);
const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M8 5v14l11-7z"/>
  </svg>
);
const BookIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
  </svg>
);

const services = [
  {
    icon: <MusicIcon />,
    iconBg: "linear-gradient(135deg, #E8540A, #FF6B2B)",
    title: "जैन संगीत व कराओके संग्रह",
    subtitle: "Music & Karaoke Collection",
    items: ["संगीत पूजा, अभिषेक पाठ", "अष्टक, स्तोत्र, अर्घ्य, जयमाला", "हिंदी | मराठी | कन्नड भाषांमध्ये", "कराओके (बिनवाणी) ट्रॅक"],
  },
  {
    icon: <VideoIcon />,
    iconBg: "linear-gradient(135deg, #F07020, #FFB347)",
    title: "पूजा-विधान व प्रात्यक्षिक",
    subtitle: "Worship Rituals & Demonstrations",
    items: ["विविध लहान-मोठी पूजा", "अभिषेक पद्धती व शांती मंत्र", "व्हिडिओ व ऑडिओ मार्गदर्शन", "शास्त्रशुद्ध विधी प्रात्यक्षिक"],
  },
  {
    icon: <BrushIcon />,
    iconBg: "linear-gradient(135deg, #FF8C00, #FFC947)",
    title: "पूजा मांडणी व मंडल",
    subtitle: "Rangoli & Mandala Designs",
    items: ["पूजेची योग्य मांडणी", "रांगोळीने मंडल रचना", "अष्टमंगल, सिद्धचक्र", "समवशरण मांडणी डिझाईन"],
  },
  {
    icon: <PdfIcon />,
    iconBg: "linear-gradient(135deg, #C0392B, #E8540A)",
    title: "विधान पुस्तके व PDF",
    subtitle: "Books & PDF Collection",
    items: ["पूजा-विधान पुस्तके", "अभिषेक, पाठ संदर्भ", "अभ्यासासाठी साहित्य", "डिजिटल संग्रह"],
  },
  {
    icon: <PlayIcon />,
    iconBg: "linear-gradient(135deg, #E8540A, #FF6B2B)",
    title: "ऑडिओ-व्हिडिओ मार्गदर्शन",
    subtitle: "Audio-Video Guidance",
    items: ["उच्चार शुद्धता", "मंत्रोच्चार प्रशिक्षण", "पाठ अभ्यास", "संपूर्ण विधी व्हिडिओ"],
  },
  {
    icon: <BookIcon />,
    iconBg: "linear-gradient(135deg, #C0392B, #E8540A)",
    title: "शास्त्रीय अभ्यासक्रम",
    subtitle: "Scriptural Study Programs",
    items: ["पूजा विधी प्रशिक्षण", "मंत्र उच्चार शिक्षण", "विधान ज्ञान", "पंडित मार्गदर्शन"],
  },
];

export default function ServicesPage() {
  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: theme.bg,
      fontFamily: "'Noto Sans Devanagari', 'Segoe UI', sans-serif",
      color: theme.text,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700;800&family=Noto+Serif+Devanagari:wght@400;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .services-header {
          text-align: center;
          padding: 72px 24px 48px;
          max-width: 800px;
          margin: 0 auto;
        }

        .eyebrow {
          font-size: 18px;
          letter-spacing: 3px;
          color: ${theme.primary};
          font-weight: 600;
          margin-bottom: 14px;
          text-transform: uppercase;
        }

        .hero-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: clamp(34px, 5.5vw, 58px);
          font-weight: 700;
          color: ${theme.text};
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .title-divider {
          width: 56px;
          height: 3px;
          background: ${theme.primary};
          margin: 0 auto 24px;
          border-radius: 2px;
        }

        .subtitle {
          font-size: 16px;
          color: ${theme.textMuted};
          line-height: 1.7;
        }

        .services-grid-wrap {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px 80px;
        }

        .services-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .service-card {
          background: #fff;
          border: 1.5px solid ${theme.border};
          border-radius: 16px;
          padding: 32px 24px 28px;
          transition: all 0.28s ease;
          cursor: default;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center; /* Center aligns the card content */
          text-align: center; /* Centers the text */
        }

        .service-card:hover {
          border-color: ${theme.primary};
          box-shadow: 0 8px 32px rgba(232,84,10,0.11);
          transform: translateY(-4px);
        }

        .icon-box {
          width: 58px;
          height: 58px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          box-shadow: 0 4px 14px rgba(232,84,10,0.28);
        }

        .card-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 18px;
          font-weight: 700;
          color: ${theme.text};
          margin-bottom: 4px;
          line-height: 1.35;
        }

        .card-subtitle {
          font-size: 13px;
          color: ${theme.primary};
          font-style: italic;
          margin-bottom: 16px;
          letter-spacing: 0.3px;
        }

        .card-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .card-list li {
          font-size: 14px;
          color: ${theme.textMuted};
          padding: 4px 0;
          position: relative;
          line-height: 1.6;
        }

        /* Bullet icon removed */
        .card-list li::before {
          content: none;
        }

        .notice-wrap {
          max-width: 780px;
          margin: 0 auto 80px;
          padding: 0 24px;
        }

        .notice-box {
          border: 2px dashed #E8A060;
          border-radius: 14px;
          padding: 36px 40px;
          text-align: center;
          background: #fff;
        }

        .notice-label {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 17px;
          font-weight: 700;
          color: ${theme.primary};
          margin-bottom: 14px;
        }

        .notice-text {
          font-size: 15px;
          color: ${theme.textMuted};
          line-height: 1.8;
        }

        @media (max-width: 960px) {
          .services-row { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 600px) {
          .services-row { grid-template-columns: 1fr; }
          .notice-box { padding: 28px 20px; }
        }
      `}</style>

      {/* Header */}
      <div className="services-header">
        <p className="eyebrow">आ म च्या  से वा</p>
        <h1 className="hero-title">आम्ही काय ऑफर करतो</h1>
        <div className="title-divider" />
        <p className="subtitle">दिगंबर जैन परंपरेतील संगीत, पूजा-विधान आणि साधनसामग्रीची संपूर्ण माहिती</p>
      </div>

      {/* Grid: 3-3 format with centered content */}
      <div className="services-grid-wrap">
        <div className="services-row">
          {services.map((s, i) => (
            <div key={i} className="service-card">
              <div className="icon-box" style={{ background: s.iconBg }}>{s.icon}</div>
              <p className="card-title">{s.title}</p>
              <p className="card-subtitle">{s.subtitle}</p>
              <ul className="card-list">
                {s.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Notice Box */}
      <div className="notice-wrap">
        <div className="notice-box">
          <p className="notice-label">विशेष सूचना</p>
          <p className="notice-text">
            हे सर्व व्हिडिओ व ऑडिओ स्वरूपात सादर करण्याचा आमचा मानस आहे, जेणेकरून प्रत्येक विधी<br />
            योग्य रीतीने, शास्त्रशुद्ध व भावपूर्ण होईल
          </p>
        </div>
      </div>
    </div>
  );
}